export default "__VITE_ASSET__DFZLsyxD__"